<template>
  <div v-if="channel" :class="`o-channel o-block-link ${channel.id} o-channel-block`"
       @click="openChannel(channel.id)"
       :style="{ color: `${channel.textColor}`, backgroundColor: `${channel.backgroundColor}`, backgroundImage : `url(${channel.backgroundImage})`}" >
    <div class="o-channel__logo"><img :src="channel.img" class="o-channel__img" width="70" height="70" alt="" /></div>
    <div v-if="channel.lastPlay" class="o-channel__content">
      <div class="o-channel__title">{{channel.lastPlay.title}}</div>
      <div class="o-channel__artist">{{channel.lastPlay.artist.name}}</div>
    </div>
    <Play class="o-channel__action" :style="{ fill: `${channel.textColor}`}" :channel="channel.id" v-on:play="on-play"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { openPlayer } from '../../mixins/radioPlayer';
  import Play from '../channelList/Play';

  export default {
    name: 'ChannelBlock',
    components: {
      Play,
    },
    props: [
      'channelid',
    ],
    mixins: [openPlayer],
    computed: {
      ...mapState({
        channels: state => state.channels.channels,
      }),
      channel() {
        return this.$store.getters['channels/channelById'](this.channelid)
      }
    }
  };
</script>
